<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'vehicle-import'"
      v-bind="observer"
      :validated="formObserver.validated"
    >
      <form-row
        gap="48"
        :question="title"
        :help-text="helpText"
        :error="formObserver.validated && observer.invalid"
      >
        <validation-provider
          v-slot="{ failed }"
          :name="questionId"
          :vid="`${stepId}_${questionId}`"
          :data-unit-test="`${stepId}_vehicle-grey-or-import_radio`"
          rules="required"
        >
          <radio
            v-model="vehicleGreyOrImportModel"
            data-test="vehicle_grey_or_import"
            :name="`${stepId}-${questionId}`"
            :items="constants.YES_NO"
            :error="failed"
            :error-messages="failed ? ['Please select if the vehicle is imported.'] : []"
          />
        </validation-provider>
      </form-row>
      <form-row
        v-if="vehicleGreyOrImportModel"
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors }"
          :data-unit-test="`${stepId}_vehicle-grey-or-import_select`"
          :vid="`${stepId}_${questionId}`"
          :name="questionId"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.vehicleGreyOrImport"
            data-test="vehicle_grey_or_import_type"
            :items="vehicleGreyOrImportOptions"
            :error-messages="errors"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select import', isMobile)"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base';
import { omit } from 'lodash';

export default {
  name: 'question-vehicle-import',
  extends: QuestionBase,
  data () {
    return {
      fields: ['vehicleGreyOrImport'],
    };
  },
  computed: {
    vehicleGreyOrImportModel: {
      get () {
        const current = this.questionData.vehicleGreyOrImport;
        if (current === null) return null;
        if (current === 'N') return false;
        return true;
      },
      set (val) {
        this.questionData.vehicleGreyOrImport = val ? '' : 'N';
      },
    },
    vehicleGreyOrImportOptions () {
      return this.helpers.createOptions({ source: omit(this.constants.VEHICLE_GREY_OR_IMPORT, ['N']) });
    },
  },
};
</script>
